import axios from "axios";

const url = process.env.REACT_APP_API_MASTER
const contentType = 'application/json'

export default class authService {

    login(USERNAME, PASSWORD) {
        return axios.post(url + '/auth/login', {
            "USERNAME": USERNAME,
            "PASSWORD": PASSWORD
        }, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    updatePass(jsondata) {
        return axios.post(url + '/auth/update-password', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

}